import React from 'react';
import styles from './Modal.module.css';

export default function Modal({ open, onClose, title, children, footer, size = 'md', className = '' }) {
  if (!open) return null;

  return (
    <div className={`${styles.overlay} ${className}`} onClick={onClose}>
      <div
        className={`${styles.modal} ${styles[size]}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {title && (
          <div className={styles.header}>
            <h3 className={styles.title}>{title}</h3>
            {onClose && (
              <button className={styles.close} onClick={onClose} aria-label="Close">
                &times;
              </button>
            )}
          </div>
        )}
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
